import Schema from 'AppReact/schema';
import { assignment, assignmentsGroup } from './types';

export default {
  overviewTabSelectedGraph: Schema('string', 'primitive', { defaultValue: 'completed' }),
  overviewTabSelectedTimeRangeId: Schema('integer', 'primitive', { defaultValue: 6 }),
  group: Schema(assignmentsGroup, 'object', { defaultValue: Schema(assignmentsGroup).sampleData() }),
  visibleAssignments: Schema(assignment, 'array', { defaultValue: [] }),
  assignmentsGroupIndex: Schema('integer', 'primitive', { defaultValue: 0 }),
  groupsCount: Schema('integer', 'primitive', { defaultValue: 0 }),
  isMobile: Schema('boolean', 'primitive', { defaultValue: false }),
  name: Schema('string', 'primitive-nullable', { defaultValue: null }),
  image: Schema('string', 'primitive-nullable', { defaultValue: null })
}